import { Skeleton } from './Skeleton';
import styles from './SkeletonText.module.scss';

export interface SkeletonTextProps {
  /** Number of text lines to render (default: 3) */
  lines?: number;
  /** Width of the last line as percentage (default: '60%') — other lines are '100%' */
  lastLineWidth?: string;
  /** Height of each line (default: '1rem') */
  lineHeight?: string;
  /** Gap between lines (default: '0.5rem') */
  gap?: string;
  /** Additional CSS class for the wrapper */
  className?: string;
}

export function SkeletonText({
  lines = 3,
  lastLineWidth = '60%',
  lineHeight = '1rem',
  gap = '0.5rem',
  className,
}: SkeletonTextProps) {
  const classes = [styles.skeletonText, className].filter(Boolean).join(' ');

  return (
    <div className={classes} style={{ gap }}>
      {Array.from({ length: lines }, (_, i) => {
        const isLast = i === lines - 1;
        return (
          <div key={i} aria-hidden="true">
            <Skeleton
              width={isLast ? lastLineWidth : '100%'}
              height={lineHeight}
            />
          </div>
        );
      })}
    </div>
  );
}

export default SkeletonText;
